import { CellTable } from "@/atoms"
import { getDefaultColumnParams } from "@/helpers/table.helpers"
import { FixInsightsCell } from "@/molecules/FixInsightsCell"
import { ImpactCell } from "@/molecules/ImpactCell"
import { IssueTitleCell } from "@/molecules/IssueTitleCell"
import { KodemScoreIssueCell } from "@/molecules/KodemScoreCell"
import { TriageIssueActionCell } from "@/molecules/TriageActionCell"
import { InsightsTriageCell } from "@/pages/TriagePage/components/molecules/InsightsTriageCell"

import type { ParamsGetColumnsTable } from "@/organisms/Drawers/components/TabDrawerTemplate"
import { KodemScoreHeaderCell } from "@/pages/TriagePage/components/molecules/KodemScoreHeaderCell"

export const getColumnsTable = ({
  orderByProps: sorter,
  t,
  internetFacingFF,
  setIssueRecord,
  onRowClick
}: ParamsGetColumnsTable) => [
  {
    title: "Issues",
    render: IssueTitleCell({ t, setRecord: setIssueRecord }),
    width: "100%",
    ...getDefaultColumnParams("packageName")
  },
  {
    title: KodemScoreHeaderCell(t),
    width: 135,
    className: "center-align-tab-template-component",
    render: KodemScoreIssueCell(t),
    ...getDefaultColumnParams("kodemScore", sorter)
  },
  {
    title: "Insights",
    width: 100,
    render: InsightsTriageCell(t, !!internetFacingFF),
    ...getDefaultColumnParams("riskInsights")
  },
  {
    title: "Fix Insights",
    render: FixInsightsCell(t),
    width: 235,
    ...getDefaultColumnParams("fixInsights")
  },
  {
    title: "Apps",
    width: 70,
    className: "center-align-tab-template-component",
    render: ImpactCell({ onRowClick }),
    ...getDefaultColumnParams("applicationCount", sorter, {
      customSorterName: "relatedApplications"
    })
  },
  {
    title: "Actions",
    width: 80,
    className: "center-align-tab-template-component",
    render: TriageIssueActionCell(t),
    ...getDefaultColumnParams("tickets")
  },
  {
    title: "Discovered",
    width: 110,
    render: CellTable,
    ...getDefaultColumnParams("discoveredDaysAgo", sorter, {
      customSorterName: "discoveredAt"
    })
  }
]
